import { useEffect } from 'react'
import { useNotifications } from 'legacy/common/utils/notifications/notifications.hooks'
import { useDashMessage } from 'intl/intl.hooks'

export const useSuccessNotification = messageId => {
  const successMessage = useDashMessage(messageId)
  const { notify } = useNotifications()
  return {
    notifySuccess: () => notify(successMessage),
  }
}

export const useErrorNotification = (error, messageId) => {
  const message = useDashMessage(messageId)
  const { notifyError } = useNotifications()
  useEffect(() => {
    if (error) {
      notifyError(message)
    }
  }, [error, message, notifyError])
}
